import { render, staticRenderFns } from "./ManualModal.vue?vue&type=template&id=3f4fb36a&scoped=true"
import script from "./ManualModal.vue?vue&type=script&lang=js"
export * from "./ManualModal.vue?vue&type=script&lang=js"
import style0 from "./ManualModal.vue?vue&type=style&index=0&id=3f4fb36a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4fb36a",
  null
  
)

export default component.exports